import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { ITabelaLaudoHigienizacao } from './listagem-higienizacao-agendada.model';
import { formatarData, formatarPlaca } from 'src/app/core/utils/utilities';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { HigienizacaoAgendadaService } from 'src/app/services/HigienizacaoAgendadaService/higienizacaoAgendada.service';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';

@Component({
  selector: 'app-listagem-higienizacao-agendada',
  templateUrl: './listagem-higienizacao-agendada.component.html',
  styleUrls: ['./listagem-higienizacao-agendada.component.scss']
})
export class ListagemHigienizacaoAgendadaComponent {
  form = this.initForm();
  tableData: ITabelaLaudoHigienizacao[] | Array<any> = [];
  id: number = Number(localStorage.getItem('id'));
  paginaAtual: number = 0;
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  isLoading: boolean = false;

  tableColumns = [
    { header: 'Código Serviço', key: 'codigo', type: 'text' },
    { header: 'Nº Agendamento', key: 'agendamento', type: 'text' },
    { header: 'Data do Serviço', key: 'servico', type: 'text' },
    { header: 'Início', key: 'entrada', type: 'text' },
    { header: 'Fim', key: 'saida', type: 'text' },
    { header: 'Placa Cavalo', key: 'placaCavalo', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          action: (item: any) => this.visualizarHigienizacaoAgendada(item)
        },
        {
          label: 'Editar',
          img: 'assets/edit.svg',
          action: (item: any) => this.editarHigienizacaoAgendada(item),
          condition: (item: any) => this.permitirEditar(item)
        },
        {
          label: 'Download Ticket',
          img: 'assets/icon-download.svg',
          action: (item: any) => this.downloadTicket(Number(item.agendamentoId))
        },
        {
          label: 'Impressão Ticket',
          img: 'assets/icon-print.svg',
          action: (item: any) => this.imprimirTicket(Number(item.agendamentoId))
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private higienizacaoAgendadaService: HigienizacaoAgendadaService,
    private appExportBase64: AppExportBase64,
    private impressoraService: ImpressoraService
  ) {}

  ngOnInit() {
    this.getHigienizacaoAgendada();
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getHigienizacaoAgendada();
    });
  }

  initForm(): FormGroup {
    const form = this.fb.group({
      FK_AGND: this.fb.control(''),
      TX_PLCA_CRRT: this.fb.control(''),
      DT_GATE_ENTR: this.fb.control('')
    });
    return form;
  }

  getHigienizacaoAgendada(pageNumber?: number): void {
    const params = this.createParams();
    this.isLoading = true;
    this.higienizacaoAgendadaService
      .GetHigienizacaoAgendadaEfetuadaPaginated({
        FK_AGND: Number(params.FK_AGND) ?? '',
        TX_PLCA_CAVA: params.TX_PLCA_CRRT ?? '',
        PAGE_NUMBER: pageNumber,
        PAGE_SIZE: 8
      })
      .subscribe({
        next: res => {
          this.isLoading = false;
          this.tableData = res.ITEMS.map(item => {
            return {
              codigo: item.PK_SRVC_ENTR ?? '---',
              agendamento: item.FK_AGND ?? '---',
              servico: formatarData(item.DT_SRVC_ENTR) ?? '---',
              entrada: formatarData(item.DT_GATE_ENTR) ?? '---',
              saida: formatarData(item.DT_GATE_SAID) ?? '---',
              placaCavalo: formatarPlaca(item.TX_PLCA_CAVA) ?? '---',
              motorista: item.NM_MTRT ?? '---',
              agendamentoId: item.FK_AGND
            };
          });
          this.maxPages = res.TOTAL_PAGES;
        },
        error: (_error: any) => {
          this.isLoading = false;
        }
      });
  }

  createParams() {
    const payload = {
      ...this.form.value
    };
    Object.keys(payload).forEach(key => key === null && delete payload[key]);
    return payload;
  }

  mudarPagina(pagina: number) {
    this.paginaAtual = pagina;
    this.getHigienizacaoAgendada(pagina + 1);
  }

  permitirEditar(item: any): boolean {
    return item.situacao;
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  navegarNovaHigienizacao() {
    this.router.navigate(['cadastro/higienizacao-agendada']);
  }

  visualizarHigienizacaoAgendada(item: any) {
    const queryParams = {
      ...item,
      isViewing: true
    };
    this.router.navigate(['cadastro/higienizacao-agendada'], {
      queryParams: queryParams
    });
  }

  editarHigienizacaoAgendada(item: any) {
    const queryParams = {
      ...item,
      isEditing: true
    };
    this.router.navigate(['cadastro/higienizacao-agendada'], {
      queryParams: queryParams
    });
  }

  downloadTicket(id: number) {
    this.isLoading = true;

    this.higienizacaoAgendadaService
      .GetReceiptHigienizacaoAgendadaById(id, 0)
      .subscribe({
        next: (response: IGetReportBase64) => {
          this.appExportBase64.downloadPDF(response.ReportBase64, 'ticket');
          this.isLoading = false;
        },
        error: _error => {
          this.isLoading = false;
        }
      });
  }

  imprimirTicket(id: number) {
    this.isLoading = true;

    this.higienizacaoAgendadaService
      .GetReceiptHigienizacaoAgendadaById(id, 1)
      .subscribe({
        next: (response: IGetReportBase64) => {
          this.isLoading = false;
          this.impressoraService.impressoraTicket(
            response.ReportBase64,
            'text/plain'
          );
        },
        error: _error => {
          this.isLoading = false;
        }
      });
  }
}
